//import AppConfig from '@/app.config.js'

import api from "@/services/apiService"

class LottoService {

  nowResult() {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_CLOUD_API + 'result')
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        });
    });
  }

  getHistories() {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_CLOUD_API + 'history')
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        });
    });
  }

  /*
  saveResult(data) {
    return new Promise((resolve, reject) => {
      api
      .post(process.env.VUE_APP_CLOUD_API + 'admin/result', data)
      .then((response)=>{
        resolve(response.data)
      })
      .catch((error)=>{
        reject(error)
      })
    });
  }

  getResults() {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_CLOUD_API + 'admin/result')
      .then((response)=>{
        resolve(response.data)
      })
      .catch((error)=>{
        reject(error)
      })
    });
  }

  getResult(id) {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_CLOUD_API + 'admin/result/' + id)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        });
    });
  }

  deleteResult(id) {
    return new Promise((resolve, reject) => {
      api.delete(process.env.VUE_APP_CLOUD_API + 'admin/result/' + id)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        })
    });
  }

  updateResult(id, data) {
    return new Promise((resolve, reject) => {
      api.put(process.env.VUE_APP_CLOUD_API + 'admin/result/' + id, data)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        });
    });
  }
  */

  randomNumber(length = 5) {
    let numbers = []
    for (let i = 1; i <= length; i++) {
      let random = Math.floor(Math.random() * 10)
      numbers.push(random)
    }
    return numbers.join('')
  }

}

export default new LottoService();
